import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSun, FaMoon } from 'react-icons/fa';

export default function Login() {
  const navigate = useNavigate();
  const [dark, setDark] = useState(true);
  const [phone, setPhone] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);
const API_URL = process.env.REACT_APP_API_URL;

  // Countdown effect
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const handleSendOtp = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`https://api.mogym.ir/api/Auth/send-otp/${phone}`, { method: 'POST' });
      if (res.status === 200) {
        setOtpSent(true);
        setCountdown(120); // 2 min
      } else {
        setError(res.Message);
      }
    } catch {
      setError('خطا در ارتباط با سرور.');
    }
    setLoading(false);
  };

  const handleVerifyOtp = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch('https://api.mogym.ir/api/Auth/login/otp/web', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phoneNumber: phone, otpCode: otp })
      });

      const data = await res.json();

      if (res.status === 200 && data.Jwt) {
        localStorage.setItem('token', data.Jwt);
        const redirect = localStorage.getItem('redirectAfterLogin');
        localStorage.removeItem('redirectAfterLogin');
        if (redirect) {
          const parsed = JSON.parse(redirect);
          navigate(parsed.to, { state: parsed.state });
        } else {
          navigate('/dashboard');
        }
      } else {
        setError(data.Message);
      }
    } catch {
      setError('خطا در ارتباط با سرور.');
    }
    setLoading(false);
  };

useEffect(() => {
  const token = localStorage.getItem('token');
  if (token) {
    navigate('/dashboard');
  }
}, [navigate]);

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-[#0e1015] text-black dark:text-white px-4 font-vazir relative">
        {/* لودینگ */}
        {loading && (
          <div className="absolute inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="w-12 h-12 border-4 border-t-blue-500 border-white rounded-full animate-spin"></div>
          </div>
        )}

        <div className="bg-white dark:bg-[#1a1d2e] p-6 rounded-xl shadow max-w-md w-full relative z-10 text-center">
          <a href='/'>
          <img src="/logo.png" alt="logo" className="w-16 h-16 mx-auto mb-4"/>
          </a>
          <h1 className="text-xl font-bold mb-6">ورود به موجیم</h1>

          {/* شماره موبایل فقط زمانی که otp ارسال نشده */}
          {!otpSent && (
            <input
              type="tel"
              placeholder="شماره موبایل"
              maxLength={11}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full p-3 mb-4 rounded-xl border dark:border-gray-600 bg-white dark:bg-[#2a2f3b]"
            />
          )}

          {/* فیلد کد تأیید */}
          {otpSent && (
            <>
              <input
                type="text"
                maxLength={6}
                minLength={6}
                placeholder="کد تایید"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                className="w-full p-3 mb-4 rounded-xl border dark:border-gray-600 bg-white dark:bg-[#2a2f3b]"
              />

              {countdown > 0 ? (
                <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">
                  ارسال مجدد کد تا {countdown} ثانیه دیگر
                </p>
              ) : (
                <button
                  onClick={handleSendOtp}
                  className="text-sm text-blue-500 hover:underline mb-4"
                >
                  ارسال مجدد کد
                </button>
              )}
            </>
          )}

          {error && <p className="text-red-500 text-sm mb-2">{error}</p>}

          {/* دکمه ها */}
          {!otpSent ? (
            <button
              onClick={handleSendOtp}
              disabled={loading || !phone}
              className="bg-blue-600 hover:bg-blue-700 text-white w-full py-2 rounded-xl disabled:opacity-50"
            >
              دریافت کد تایید
            </button>
          ) : (
            <button
              onClick={handleVerifyOtp}
              disabled={loading || !otp}
              className="bg-green-600 hover:bg-green-700 text-white w-full py-2 rounded-xl disabled:opacity-50"
            >
              ورود
            </button>
          )}

          {/* قوانین */}
          <p className="text-xs text-center text-gray-500 dark:text-gray-400 mt-4">
            با ورود به موجیم شما{' '}
            <a href="/terms" className="text-blue-500 hover:underline">
              قوانین و مقررات اپلیکیشن
            </a>{' '}
            را پذیرفته‌اید.
          </p>
        </div>

        {/* کلید روشن/تیره */}
        <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg flex items-center justify-center"
        >
          {dark ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-blue-500" />}
        </button>
      </div>
    </div>
  );
}
